import { useUserContext } from '@osmosis/nextjs-components/context/UserContext';
import { useEmbedOverlay } from '@osmosis/nextjs-components/context/EmbedProvider';
import { useCallback, useEffect, useRef, useState } from 'react';
import useUpdateTrialMetadata from '../../hooks/useUpdateTrialMetadata';
import TrialAbuseRestrictionModal from './TrialAbuseRestrictionModal';
import { useTrialAbuseRestrictionCoordinator } from './TrialAbuseRestrictionCoordinator';

const TRIAL_ABUSE_RESTRICTION_OVERLAY_ID = 'trial-abuse-restriction';

/**
 * Shows the trial-abuse restriction once per authenticated page entry.
 */
export default function TrialAbuseRestrictionGate() {
  const { isUserLoaded, trialAbuseRestricted, user } = useUserContext();
  const [isVisible, setIsVisible] = useState(false);
  const shownForMountedEntry = useRef(false);
  const coordinator = useTrialAbuseRestrictionCoordinator();

  useUpdateTrialMetadata();

  const hideRestriction = useCallback(() => {
    coordinator?.dismissVisibleRequests();
    setIsVisible(false);
  }, [coordinator]);

  useEmbedOverlay({
    id: TRIAL_ABUSE_RESTRICTION_OVERLAY_ID,
    isOpen: isVisible,
    onClose: hideRestriction,
  });

  useEffect(() => {
    if (isUserLoaded && (!user || !trialAbuseRestricted)) {
      setIsVisible(false);
      return;
    }
    if (
      isUserLoaded &&
      user &&
      trialAbuseRestricted &&
      !shownForMountedEntry.current
    ) {
      shownForMountedEntry.current = true;
      setIsVisible(true);
    }
  }, [isUserLoaded, trialAbuseRestricted, user]);

  return (
    <TrialAbuseRestrictionModal isVisible={isVisible} hide={hideRestriction} />
  );
}
